import { render, staticRenderFns } from "./NavLanguageSwitch.vue?vue&type=template&id=3029d9b0&scoped=true"
import script from "./NavLanguageSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./NavLanguageSwitch.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NavLanguageSwitch.vue?vue&type=style&index=0&id=3029d9b0&prod&lang=less"
import style1 from "./NavLanguageSwitch.vue?vue&type=style&index=1&id=3029d9b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3029d9b0",
  null
  
)

export default component.exports